import { render, staticRenderFns } from "./WorkDetailFile.vue?vue&type=template&id=feeae302&scoped=true"
import script from "./WorkDetailFile.vue?vue&type=script&lang=js"
export * from "./WorkDetailFile.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailFile.vue?vue&type=style&index=0&id=feeae302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feeae302",
  null
  
)

export default component.exports